<SearchResult href="/tags/{hashtag.name.toLowerCase()}">
  {'#' + hashtag.name}
</SearchResult>
<style>
</style>
<script>
  import SearchResult from './SearchResult.html'
  export default {
    components: {
      SearchResult
    }
  }
</script>
